<script setup lang="ts">
import { vaccines } from '@/components/reason/reasonFormData';
import { Checkbox } from '@/components/ui/checkbox';
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form';
import { vAutoAnimate } from '@formkit/auto-animate/vue';
import { Asterisk, ChevronDown } from 'lucide-vue-next';
import { ref } from 'vue';

const isExpanded = ref(false);
</script>

<template>
    <FormField name="vaccines">
        <FormItem v-auto-animate class="space-y-2.5">
            <div>
                <span class="text-md font-semibold align-middle">
                    Select a vaccine you need a prescription for:
                    <Asterisk class="text-red-600 size-4 inline-block" />
                </span>
                <div class="text-sm font-medium text-gray-400">We currently only support the vaccines listed below.
                </div>
            </div>
            <div class="grid gap-y-3">
                <FormField v-for="vaccine in vaccines" v-slot="{ value, handleChange }" :key="vaccine.id"
                    type="checkbox" :value="vaccine.name" :unchecked-value="false" name="vaccines">
                    <FormItem class="flex flex-row items-center space-x-2 space-y-0 cursor-pointer select-none">
                        <FormControl>
                            <Checkbox :checked="value?.includes(vaccine.name)" class="border-gray-600 h-5 w-5"
                                @update:checked="handleChange" />
                        </FormControl>
                        <FormLabel
                            class="font-normal py-1 cursor-pointer w-full leading-normal text-gray-800 active:scale-95 transition-all ease-in-out duration-100 origin-left">
                            {{ vaccine.label }}
                        </FormLabel>
                    </FormItem>
                </FormField>
            </div>
            <FormMessage />
            <div class="rounded-xl bg-orange-100 p-4 space-y-2 border border-orange-200">
                <div class="flex text-orange-900 font-bold gap-x-2">
                    Looking for a different vaccine?
                </div>
                <p class="text-gray-800 font-medium text-md" @click="isExpanded = true">
                    <span v-if="!isExpanded">
                        Please visit a pharmacist, public health unit, or a walk‑in clinic.

                        <button type="button"
                            class="text-orange-800 hover:text-orange-700 font-semibold text-sm ml-1 inline">
                            See more
                            <ChevronDown class="size-4 inline-block" />
                        </button>
                    </span>
                    <span v-else>
                        For other vaccines, visit a pharmacist, public health unit, or a walk-in clinic. Travel vaccines
                        are available at travel clinics (not covered by provincial health plans).
                    </span>
                </p>
            </div>
        </FormItem>
    </FormField>
</template>
